// Annual vehicle-tax weight brackets. A row is [threshold, price]: the first row
// whose threshold is LESS than the weight wins, otherwise the fallback price.
// Comparisons stay loose on purpose (weight may be '' or a numeric string).

export function lookupByWeight(table, fallback, weight) {
  for (let i = 0; i < table.length; i++) {
    if (weight > table[i][0]) return table[i][1];
  }
  return fallback;
}

// รย.3 รถบรรทุกส่วนบุคคล
export const CT3_TABLE = [
  [2000, 1650], [1750, 1350], [1500, 1050], [1250, 900],
  [1000, 750], [750, 600], [500, 450]
];
export const CT3_FALLBACK = 300;

// รย.2 รถยนต์นั่งเกิน 7 คน (also used by ขส.40 / ขส.80 and by รย.1 electric)
export const CT2_TABLE = [
  [7000, 3600], [6000, 3400], [5000, 3200], [4500, 3000], [4000, 2800],
  [3500, 2600], [3000, 2400], [2500, 2200], [2000, 1900], [1750, 1600],
  [1500, 1300], [1250, 1000], [1000, 800], [750, 450], [500, 300]
];
export const CT2_FALLBACK = 150;

// ขส.10 รถโดยสารประจำทาง
export const CT6_TABLE = [
  [7000, 2900], [6000, 2700], [5000, 2500], [4500, 2300], [4000, 2100],
  [3500, 1900], [3000, 1700], [2500, 1500], [2000, 1300], [1750, 1100],
  [1500, 900], [1250, 700], [1000, 600], [750, 500], [500, 400]
];
export const CT6_FALLBACK = 300;

// ขส.30 / ขส.70
export const CT7_CT9_TABLE = [
  [7000, 4350], [6000, 4050], [5000, 3750], [4500, 3450], [4000, 3150],
  [3500, 2850], [3000, 2540], [2500, 2250], [2000, 1950], [1750, 1650],
  [1500, 1350], [1250, 1050], [1000, 900], [750, 750], [500, 600]
];
export const CT7_CT9_FALLBACK = 450;
